<div class="side-bar" [class.is-open]="isOpen">
  <div class="d-flex flex-column info-container">
    <div class="header-img">
      <img src="assets/images/white-logo.png" alt="logo">
    </div>
  </div>

  <ul class="nav-list nav-list--taxi" *ngIf="auth.isTaxiOfficeSession()">
    <li routerLinkActive="Active">
      <a routerLink="/taxi/overview" routerLinkActive="Active">
        <span class="nav-list__icon nav-list__icon--overview" aria-hidden="true"></span>
        {{ taxiKeys.nav.overview | translate }}
      </a>
    </li>
    <li routerLinkActive="Active">
      <a routerLink="/taxi/drivers" routerLinkActive="Active">
        <span class="nav-list__icon nav-list__icon--drivers" aria-hidden="true"></span>
        {{ taxiKeys.nav.drivers | translate }}
      </a>
    </li>
    <li routerLinkActive="Active">
      <a routerLink="/taxi/transactions" routerLinkActive="Active">
        <span class="nav-list__icon nav-list__icon--settlements" aria-hidden="true"></span>
        {{ taxiKeys.nav.settlements | translate }}
      </a>
    </li>
  </ul>

  <ul class="nav-list nav-list--taxi" *ngIf="auth.isTransitOperatorSession()">
    <li *ngFor="let item of transitNav" routerLinkActive="Active">
      <a [routerLink]="item.path" routerLinkActive="Active">
        <span class="nav-list__icon nav-list__icon--{{ item.icon }}" aria-hidden="true"></span>
        {{ item.label | translate }}
      </a>
    </li>
  </ul>

  <ng-container *ngIf="auth.isStoreSession()">
    <ul class="nav-list">
      <li routerLinkActive="Active">
        <a routerLink="/dashboard" routerLinkActive="Active">
          <img alt="icon"
            [src]="!currentUrl || currentUrl.startsWith('/dashboard') ? 'assets/images/dashboard-active.svg' : 'assets/images/dashboard.svg'">
          {{ 'store.nav.dashboard' | translate }}
        </a>
      </li>

      <li routerLinkActive="Active">
        <a routerLink="/transactions" routerLinkActive="Active">
          <img alt="icon"
            [src]="currentUrl && currentUrl.startsWith('/transactions') ? 'assets/images/transactions-active.svg' : 'assets/images/transactions.svg'">
          {{ 'store.nav.transactions' | translate }}
        </a>
      </li>
      <li *ngIf="(featureFlagService.isFeatureEnabled$('biller_direct_pay') | async)" routerLinkActive="Active">
        <a routerLink="/biller" routerLinkActive="Active">
          <img alt="icon"
            [src]="currentUrl && currentUrl.startsWith('/biller') ? 'assets/images/transactions-active.svg' : 'assets/images/transactions.svg'">
          {{ 'store.nav.biller' | translate }}
        </a>
      </li>

      <li *ngIf="(voucherSectionEnabled$ | async)">
        <a (click)="toggleVoucherSection()" class="ecommerce-header">
          {{ 'store.nav.vouchers' | translate }}
          <span [ngClass]="{'arrow-down': isVoucherOpen, 'arrow-right': !isVoucherOpen}"></span>
        </a>
        <ul *ngIf="isVoucherOpen" class="ecommerce-submenu">
          <li *ngIf="(featureFlagService.isFeatureEnabled$('store_vouchers') | async)">
            <a routerLink="/vouchers" routerLinkActive="Active">
              <img alt="icon"
                [src]="currentUrl && currentUrl.startsWith('/vouchers') ? 'assets/images/vouchers-active.svg' : 'assets/images/vouchers.svg'">
              {{ 'store.nav.vouchers' | translate }}
            </a>
          </li>
          <li *ngIf="(featureFlagService.isFeatureEnabled$('store_vouchers_orders') | async)">
            <a routerLink="/orders" routerLinkActive="Active">
              <img alt="icon"
                [src]="currentUrl && currentUrl.startsWith('/orders') ? 'assets/images/orders-active.svg' : 'assets/images/orders.svg'">
              {{ 'store.nav.orders' | translate }}
            </a>
          </li>
          <li *ngIf="(featureFlagService.isFeatureEnabled$('store_voucher_offer') | async)">
            <a routerLink="/voucher-bonus" routerLinkActive="Active">
              <img alt="icon"
                [src]="currentUrl && currentUrl.startsWith('/voucher-bonus') ? 'assets/images/vouchers-active.svg' : 'assets/images/vouchers.svg'">
              {{ 'store.nav.voucherBonus' | translate }}
            </a>
          </li>
        </ul>
      </li>

      <li *ngIf="(ecommerceSectionEnabled$ | async)">
        <a (click)="toggleEcommerceSection()" class="ecommerce-header">
          {{ 'store.nav.ecommerce' | translate }}
          <span [ngClass]="{'arrow-down': isEcommerceOpen, 'arrow-right': !isEcommerceOpen}"></span>
        </a>
        <ul *ngIf="isEcommerceOpen" class="ecommerce-submenu">
          <li *ngIf="(featureFlagService.isFeatureEnabled$('store_product') | async)">
            <a routerLink="/ecommerce/products" routerLinkActive="Active">
              <img alt="icon"
                [src]="currentUrl && currentUrl.startsWith('/ecommerce/products') ? 'assets/images/vouchers-active.svg' : 'assets/images/vouchers.svg'">
              {{ 'store.nav.products' | translate }}
            </a>
          </li>
          <li *ngIf="(featureFlagService.isFeatureEnabled$('store_categories') | async)">
            <a routerLink="/ecommerce/categories" routerLinkActive="Active">
              <img alt="icon"
                [src]="currentUrl && currentUrl.startsWith('/ecommerce/categories') ? 'assets/images/redemptions-active.svg' : 'assets/images/redemptions.svg'">
              {{ 'store.nav.categories' | translate }}
            </a>
          </li>
          <li *ngIf="(featureFlagService.isFeatureEnabled$('store_orders') | async)">
            <a routerLink="/ecommerce/orders" routerLinkActive="Active">
              <img alt="icon"
                [src]="currentUrl && currentUrl.startsWith('/ecommerce/orders') ? 'assets/images/orders-active.svg' : 'assets/images/orders.svg'">
              {{ 'store.nav.orders' | translate }}
            </a>
          </li>
        </ul>
      </li>
    </ul>

    <ul class="bottom-list">
      <li *ngIf="(featureFlagService.isFeatureEnabled$('store_settings') | async)">
        <a routerLink="/settings" routerLinkActive="Active">
          <img alt="icon"
            [src]="currentUrl && currentUrl.startsWith('/settings') ? 'assets/images/settings-active.svg' : 'assets/images/settings.svg'">
          {{ 'store.nav.settings' | translate }}
        </a>
      </li>
      <li>
        <a (click)="logout()" role="button" tabindex="0">
          <img alt="icon" src="assets/images/logout.png">
          {{ 'store.nav.logout' | translate }}
        </a>
      </li>
    </ul>
  </ng-container>

  <ul class="bottom-list" *ngIf="auth.isProviderSession()">
    <li>
      <a (click)="logout()" role="button" tabindex="0">
        <img alt="icon" src="assets/images/logout.png">
        {{ (auth.isTransitOperatorSession() ? transitKeys.nav.logout : taxiKeys.nav.logout) | translate }}
      </a>
    </li>
  </ul>
</div>
